import { render, staticRenderFns } from "./SharingPage.vue?vue&type=template&id=127b3dc2&scoped=true"
import script from "./SharingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharingPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SharingPage.vue?vue&type=style&index=0&id=127b3dc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127b3dc2",
  null
  
)

export default component.exports